
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mail': {
    width: 493.5,
    height: 323.1,
    viewBox: '0 0 493.5 323.1',
    data: '<path pid="0" d="M444.6 0H48.9C22 0 0 22 0 48.9v225.2c0 27 22 48.9 48.9 48.9h395.6c27 0 48.9-22 48.9-48.9V48.9C493.5 22 471.5 0 444.6 0zm16.3 48.9v225.2c0 2.6-.7 4.9-1.8 7.1L343.7 165.9 460.8 48.8l.1.1zM32.6 274.1V48.7l117.1 117.1L34.4 281.2c-1-2.2-1.8-4.5-1.8-7.1zm219.2-62.4c-2.7 2.7-7.4 2.7-10.1 0L62.7 32.6h368.2L251.8 211.7zm-79-22.8l45.8 45.8c7.5 7.5 17.5 11.6 28.1 11.6 10.6 0 20.6-4.1 28.1-11.6l45.8-45.8 101.5 101.5H71.3l101.5-101.5z"/>'
  }
})
